<template>
  <div class="transfer-download">
    <div class="main">
      <div class="logo">
        <img src="../assets/RideArt_logo.svg">
      </div>
      <div class="app-info">
        <p class="header-text">
          Download the
          <strong> {{ getAppName }}</strong>
           app for iOS or android
        </p>
        <ol>
          <li>Download the app.</li>
          <li>Complete the sign up process.</li>
          <li>Click the link to claim your {{ getAppName }} pass.</li>
        </ol>
        <div class="store-buttons">
          <a v-if="getAppStore" :href="getAppStore"><img src="../assets/app_store.svg"></a>
          <a v-if="getPlayStore" :href="getPlayStore"><img src="../assets/play_store.svg"></a>
        </div>
      </div>
      <div class="app-img-container">
        <img class="app-img" src="../assets/app_passes_screen.png"
        srcset="../assets/app_passes_screen@2x.png, ../assets/app_passes_screen@3x.png">
      </div>
    </div>
    <div class="version-info">
      Powered by Routematch © {{date.getFullYear()}} | Version {{packageVersion}}
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState(['array']),
    ...mapGetters('agenciesData', ['getAbbriviation', 'getAppName', 'getAppStore', 'getPlayStore']),
  },

  data: () => ({
    date: new Date(),
    config: null,
    // eslint-disable-next-line
    packageVersion: require('../../package.json').version,
  }),
  name: 'RideART',
};
</script>

<style lang="scss">
  html {
    height: 100%;
  }
  body {
    height: 100%;
    margin: 0px;
  }
  .main {
    width: 100%;
    height: 100%;
  }
  .transfer-download {
    height: 100%;
  }
  .version-info {
    float: left top;
    position: absolute;
    top: 0;
    z-index: -1;
    color: white
  }
  @media only screen and (max-width: 480px) {

    .logo {
      text-align: center;
      width: 100%;
      padding: 20px 0px 20px 0px ;
      margin: 0px;
    }
    .app-img-container {
      float: left ;
      background-position: top right ;
      background-image: url('../assets/small_splodge.svg');
      background-repeat: no-repeat;
      background-size: cover;
      width: 100% ;
      .app-img {
        width: 75%;
      }
    }
    .app-info {
      padding-left: 10% ;
      width: 80% ;
      text-align: left;
      padding-bottom: 30px;
      ol {
        font-size: 20px ;
      }
      .header-text {
        width: 80% ;
        font-size: 30px;
        padding-left: 10px;
      }
      .store-buttons{
        a {
          margin-left: 14px ;
          padding-bottom: 30px;
        }
      }
    }
  }
  @media only screen and (max-width: 801px) and (min-width: 480px){
    .logo {
      width: 30%;
      text-align: left;
      padding: 70px 0px 0px 11%;
    }
    .app-img-container {
      float: right;
      background-position: top right ;
      background-image: url('../assets/medium_splodge.svg');
      background-repeat: no-repeat;
      background-size: contain;
      width: 50% ;
      height: 600px;
      position:absolute;
      top:0;
      right:0;
      .app-img {
        width: 70%;
        padding-top: 70px ;
        float: right;
        padding-right: 30px ;
      }
    }
    .app-info {
      padding-left: 10%;
      width: 40% ;
      text-align: left;
      ol {
        font-size: 20px ;
      }
      .header-text {
        width: 80% ;
        font-size: 30px ;
        padding-left: 10px;
      }
      .store-buttons{
        img {
          padding-left: 10px;
          padding-bottom: 10px;
        }
      }
    }
  }
  @media only screen and (max-width: 1024px) and (min-width: 801px){
    .logo {
      width: 20%;
      text-align: left;
      padding: 80px 0px 0px 120px;
    }
    .app-img-container {
      float: right;
      background-position: top right ;
      background-image: url('../assets/large_splodge.svg');
      background-repeat: no-repeat;
      background-size: contain;
      width: 60%;
      min-height: 600px;
      position:absolute;
      top:0;
      right:0;
      .app-img {
        width: 40%;
        padding-top: 100px ;
        float: right;
        padding-right: 110px ;
      }
    }
    .app-info {
      padding-left: 10%;
      width: 40% ;
      text-align: left;
      ol {
        font-size: 20px ;
      }
      .header-text {
        padding-left: 15px;
        width: 80% ;
        font-size: 30px ;
      }
      .store-buttons{
        img {
          padding: 18px 5px;
        }
      }
    }
  }
  @media only screen and (max-width: 1600px) and (min-width: 1025px){
    .logo {
      width: 20%;
      text-align: left;
      padding: 100px 0px 0px 150px;
    }
    .app-img-container {
      float: right;
      background-position: top right ;
      background-image: url('../assets/large_splodge.svg');
      background-repeat: no-repeat;
      background-size: contain;
      width: 60%;
      min-height: 600px;
      position:absolute;
      top:0;
      right:0;
      .app-img {
        width: 35%;
        padding-top: 100px ;
        float: right;
        padding-right: 110px ;
      }
    }
    .app-info {
      padding-left: 10% ;
      width: 30% ;
      text-align: left;
      ol {
        font-size: 20px ;
      }
      .header-text {
        padding-left: 15px;
        width: 80% ;
        font-size: 40px ;
      }
      .store-buttons{
        img {
          padding: 18px 10px;
        }
      }
    }
  }
  @media only screen and (min-width: 1600px){
    .logo {
      width: 20%;
      text-align: center;
      padding: 130px 0px 0px 100px;
    }
    .app-img-container {
      float: right;
      background-position: top right;
      background-image: url('../assets/large_splodge.svg');
      background-repeat: no-repeat;
      width: 70%;
      height: 968px;
      position:absolute;
      top:0;
      right:0;
      .app-img {
        width: 25%;
        padding-top: 100px ;
        float: right;
        padding-right: 180px ;
      }
    }
    .app-info {
      padding-left: 10%;
      width: 20% ;
      text-align: left;
      ol {
        font-size: 26px;
      }
      .header-text {
        width: 519px;
        font-size: 50px;
        padding-left: 10px;
      }
      .store-buttons{
        img {
          padding-left: 10px;
          padding-bottom: 10px;
        }
      }
    }
  }
  // .main{
  //   .logo {
  //     width: 25%;
  //     padding-left: 50px;
  //     padding-top: 20px;
  //     margin-bottom: 4vh;
  //     float: left;
  //   }
  //   .app-img-container {
  //     position: relative;
  //     z-index: 2;
  //     height: 100%;
  //     width: 50%;
  //     float: right;
  //     background-image: url('../assets/medium_splodge.svg');
  //     background-repeat: no-repeat;
  //     background-position: 40px 0px;
  //     background-size: contain;
  //     .app-img {
  //       position: relative;
  //       top: 30px;
  //       left: 10px;
  //     }
  //   }
  //   .app-info {
  //     padding-top: 30px;
  //     width: 50%;
  //     padding-left: 50px;
  //     position: relative;
  //     z-index: 3;
  //     top: 0px;
  //     left: 0px;
  //     text-align: left;
  //     ol {
  //       font-family: Lato;
  //       font-size: 26px;
  //       line-height: 1.54;
  //       color: #3a4250;
  //     }
  //     .header-text {
  //       padding-left: 10px;
  //       width: 527px;
  //       font-family: Lato;
  //       font-size: 50px;
  //       line-height: 1.4;
  //       color: #141414;
  //     }
  //     .store-buttons{
  //       a {
  //         margin-left: 40px;
  //       }
  //     }
  //   }
  //   height: 100%;
  //   width: 100%;
  // }

  // @media only screen and (max-width: 480px) {
  //   .logo {
  //     text-align: center;
  //     width: 100vw !important;
  //     padding: 10px 0px 0px 0px !important;
  //     margin: 0px;
  //   }
  //   .app-img-container {
  //     float: left !important;
  //     background-position: top right !important;
  //     background-image: url('../assets/small_splodge.svg') !important;
  //     width: 100% !important;
  //     .app-img {
  //       top: 20px !important;
  //       left: 15px !important;
  //     }
  //   }
  //   .app-info {
  //     padding-left: 12% !important;
  //     width: 84% !important;
  //     ol {
  //       font-size: 20px !important;
  //     }
  //     .header-text {
  //       width: 70% !important;
  //       font-size: 40px !important;
  //     }
  //     .store-buttons{
  //       a {
  //         margin-left: 10px !important;
  //         padding-bottom: 30px;
  //       }
  //     }
  //   }
  // }

  // @media only screen and (max-width: 801px) and (min-width: 480px){
  //   .logo {
  //     text-align: left;
  //     width: 30% !important;
  //     padding:10px 0px 0px 50px !important;
  //     margin: 0px;
  //   }
  //   .app-img-container {
  //     width: 50% !important;
  //     height: 150vh !important;
  //   }
  //   .app-info {
  //     width: 100% !important;
  //     padding:0px 0px 0px 40px !important;
  //     ol {
  //       font-size: 20px !important;
  //     }
  //     .header-text {
  //       width: 30% !important;
  //       font-size: 40px !important;
  //     }
  //     .store-buttons{
  //       a {
  //         margin-left: 10px !important;
  //         padding-bottom: 30px;
  //       }
  //     }
  //   }
  // }
</style>
